/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDeclineAccessRequestResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeDeclineAccessRequestRequest, serializeDeclineAccessRequestResponse, type DeclineAccessRequestRequest, type DeclineAccessRequestResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/access-requests/{accessRequestId}/decline
 */
export interface DeclineRequestBuilder extends BaseRequestBuilder<DeclineRequestBuilder> {
    /**
     * Declines an access request and notifies the requester
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DeclineAccessRequestResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: DeclineAccessRequestRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DeclineAccessRequestResponse | undefined>;
    /**
     * Declines an access request and notifies the requester
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: DeclineAccessRequestRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DeclineRequestBuilderUriTemplate = "{+baseurl}/api/organizations/access-requests/{accessRequestId}/decline";
/**
 * Metadata for all the requests in the request builder.
 */
export const DeclineRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: DeclineRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDeclineAccessRequestResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeclineAccessRequestRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
